import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../../_services/langhfre.service';
import { NavigationService } from 'src/app/_services/navigation.service';
@Component({
  selector: 'app-academic-institutions',
  templateUrl: './academic-institutions.component.html',
  styleUrls: ['./academic-institutions.component.scss']
})
export class AcademicInstitutionsComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    public navigationService: NavigationService
  ) {
  }

  ngOnInit() {
    this.titleService.setTitle("Trinka 企業方案｜學術機構專屬方案");
    this.metaTagService.updateTag({ name: 'description', content: "Trinka 幫助您優化學術寫作，符合學術寫作規範與最佳實踐，讓論文輕鬆達到投稿標準。" });
    this.metaTagService.updateTag({ property: 'og:title', content: "Trinka 企業方案｜學術機構專屬方案" });
    this.metaTagService.updateTag({ property: 'og:description', content: "Trinka 幫助您優化學術寫作，符合學術寫作規範與最佳實踐，讓論文輕鬆達到投稿標準。" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/enterprise/academic-institutions' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'zh-tw' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/enterprise/academic-institutions' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/enterprise/academic-institutions' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/enterprise/academic-institutions' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/enterprise/academic-institutions' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/enterprise/academic-institutions' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/enterprise/academic-institutions' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/enterprise/academic-institutions' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/enterprise/academic-institutions' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/enterprise/academic-institutions' });

  }
  
}
